import { useCallback, useEffect, useState } from 'react';
import QualityLevel from 'videojs-contrib-quality-levels/dist/types/quality-level';

import { XingPlayer } from '../types/xing-player';

const sortQualityLevels = (qualityLevels: QualityLevel[]): QualityLevel[] =>
  qualityLevels.sort((a, b) => (a.height ?? 0) - (b.height ?? 0));

export const useQualityLevel = (
  player: XingPlayer['videojs']
): {
  qualityLevels: QualityLevel[];
  selectedQualityLevel: QualityLevel | null;
  selectQualityLevel: (id: string) => void;
} => {
  const [qualityLevels, setQualityLevels] = useState<QualityLevel[]>([]);
  const [selectedQualityLevel, setSelectedQualityLevel] =
    useState<QualityLevel | null>(null);

  // @ts-expect-error TODO: qualityLevels types are not available in v8
  // TODO: There is a known bug where the qualityLevels are not properly updated
  const controller = player.qualityLevels();

  useEffect(() => {
    const handleAddQualityLevel = ({
      qualityLevel,
    }: {
      qualityLevel: QualityLevel;
    }): void => {
      const exist = qualityLevels.find(({ id }) => id === qualityLevel.id);
      if (!exist) {
        setQualityLevels((current) =>
          sortQualityLevels([...current, qualityLevel])
        );
      }
    };

    controller.on('addqualitylevel', handleAddQualityLevel);

    const handleChange = ({
      selectedIndex,
    }: {
      selectedIndex: number;
    }): void => {
      setSelectedQualityLevel(controller.levels_[selectedIndex]);
    };

    controller.on('change', handleChange);

    return () => {
      controller.off('addqualitylevel', handleAddQualityLevel);
      controller.off('change', handleChange);
    };
  }, [controller, qualityLevels]);

  return {
    qualityLevels,
    selectedQualityLevel,
    selectQualityLevel: useCallback(
      (id: string): void => {
        const index = controller.levels_.findIndex(
          (quality: any) => quality.id === id
        );
        if (index !== -1) {
          controller.selectedIndex_ = index;
          controller.trigger({ type: 'change', selectedIndex: index });
        }
      },
      [controller]
    ),
  };
};
